import { DragTool } from './DragTool';
export default DragTool;